import React from "react";

export const LogoMark = ({ size = 44, className = "" }) => (
  <img
    src="/prospera-logo-transparent.png"
    width={size}
    height={size}
    alt="Prospera Staffing logo"
    className={`shrink-0 ${className}`}
    style={{ objectFit: "contain" }}
  />
);

export const BrandText = ({ dark = false, large = false }) => (
  <span className="font-accent leading-none tracking-wide flex flex-col justify-center gap-[3px]">
    <span className={large ? "text-xl sm:text-2xl" : "text-lg sm:text-xl"}>
      <span className="text-[#C62828]" style={{ fontWeight: 700 }}>
        PROSPERA
      </span>{" "}
      <span
        className={dark ? "text-[#F7F7F5]" : "text-[#1F1F1F]"}
        style={{ fontWeight: 500 }}
      >
        STAFFING
      </span>
    </span>
    <span
      className={`uppercase ${large ? "text-[10px] sm:text-[11px]" : "text-[10px] sm:text-[11px]"} tracking-[0.16em] ${
        dark ? "text-[#F7F7F5]" : "text-[#1F1F1F]"
      }`}
      style={{ fontWeight: 600 }}
    >
      Solutions and FZCO
    </span>
  </span>
);

export const Logo = ({ dark = false, onClick, size = 44 }) => (
  <a
    href="#home"
    onClick={onClick}
    data-testid="logo-link"
    className="flex items-center gap-2.5 group select-none"
    aria-label="Prospera Staffing home"
  >
    <LogoMark size={size} className="transition-transform duration-500 group-hover:rotate-[-6deg]" />
    <BrandText dark={dark} />
  </a>
);

export default Logo;
